var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useLocalData } from '@base/LocalDataContext';
import { useMutation, useQueries, useQuery, useQueryClient, } from '@tanstack/react-query';
import { reorder } from '../../util/sort';
import { usePermittedActionsList } from '../permission/permissionActions';
import { sheetRowsApi } from '../rest/api';
import { selectActionsBySheetRowId, SheetRowPath } from './sheetRow';
export var sheetRowKeys = {
    all: ['sheetRows'],
    list: function () {
        return __spreadArray(__spreadArray([], __read(sheetRowKeys.all), false), ['list'], false);
    },
    details: function (sheetRowId) {
        return __spreadArray(__spreadArray([], __read(sheetRowKeys.all), false), ['details', sheetRowId], false);
    },
    searches: function () {
        return __spreadArray(__spreadArray([], __read(sheetRowKeys.all), false), ['search'], false);
    },
    search: function (path, expressions, withData, numberColumnsData) {
        return __spreadArray(__spreadArray([], __read(sheetRowKeys.searches()), false), [path, expressions, withData, numberColumnsData], false);
    },
    actions: function () {
        return __spreadArray(__spreadArray([], __read(sheetRowKeys.all), false), ['actions'], false);
    },
};
function findAll() {
    return sheetRowsApi.list();
}
export function useSheetRows(options) {
    var listKey = sheetRowKeys.list();
    return useQuery(listKey, findAll, options);
}
function get(context) {
    var _a = __read(context.queryKey, 3), sheetRowId = _a[2];
    if (!sheetRowId) {
        throw Error('Invalid query');
    }
    return sheetRowsApi.get(sheetRowId);
}
export function useGetSheetRow(sheetRowId) {
    var queryKey = sheetRowKeys.details(sheetRowId);
    return useQuery(queryKey, get, { enabled: !!sheetRowId });
}
function create(newSheetRow) {
    return sheetRowsApi.create(newSheetRow);
}
export function useCreateSheetRow() {
    var queryClient = useQueryClient();
    return useMutation(create, {
        onMutate: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.cancelQueries(sheetRowKeys.all)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        onSuccess: function (data, variables, context) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: 
                        //Get parent path and invalidate it
                        return [4 /*yield*/, queryClient.invalidateQueries(sheetRowKeys.all)];
                        case 1:
                            //Get parent path and invalidate it
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    });
}
function _delete(sheetRowId) {
    return sheetRowsApi._delete(sheetRowId);
}
export function useDeleteSheetRow() {
    var allSearchesKey = sheetRowKeys.searches();
    var listKey = sheetRowKeys.list();
    var queryClient = useQueryClient();
    return useMutation(_delete, {
        onMutate: function (id) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var oldList, allSearchedRows, hasFoundParent, parentId, newQueryData, oldQueryData, getUpdatedParent, allSearchedRows_1, allSearchedRows_1_1, _c, queryKey, rows, pathSegments, sheetRowIdSegments, newQueryData_1, newQueryData_1_1, _d, key, data, parentData, parentData_1, parentData_1_1, _e, key, data;
                var e_1, _f, e_2, _g, e_3, _h;
                return __generator(this, function (_j) {
                    switch (_j.label) {
                        case 0: return [4 /*yield*/, queryClient.cancelQueries(listKey)];
                        case 1:
                            _j.sent();
                            return [4 /*yield*/, queryClient.cancelQueries(allSearchesKey)];
                        case 2:
                            _j.sent();
                            oldList = queryClient.getQueryData(listKey);
                            queryClient.setQueryData(listKey, function (data) {
                                return data === null || data === void 0 ? void 0 : data.filter(function (d) { return d.id !== id; });
                            });
                            allSearchedRows = queryClient.getQueriesData(allSearchesKey);
                            hasFoundParent = false;
                            newQueryData = [];
                            oldQueryData = [];
                            getUpdatedParent = function (data) {
                                var updatedChildren = data.children.filter(function (c) { return c.id !== id; });
                                return __assign(__assign({}, data), { children: updatedChildren, 
                                    // update the chevron
                                    current: data.current ? __assign(__assign({}, data.current), { hasChildren: updatedChildren.length > 0 }) : undefined });
                            };
                            try {
                                for (allSearchedRows_1 = __values(allSearchedRows), allSearchedRows_1_1 = allSearchedRows_1.next(); !allSearchedRows_1_1.done; allSearchedRows_1_1 = allSearchedRows_1.next()) {
                                    _c = __read(allSearchedRows_1_1.value, 2), queryKey = _c[0], rows = _c[1];
                                    if (!rows) {
                                        continue;
                                    }
                                    if (((_a = rows.current) === null || _a === void 0 ? void 0 : _a.id) === id) {
                                        oldQueryData.push([queryKey, rows]);
                                        newQueryData.push([queryKey, undefined]);
                                        parentId = rows.current.parentId;
                                        continue;
                                    }
                                    // parent found, filter children
                                    if (((_b = rows.current) === null || _b === void 0 ? void 0 : _b.id) === parentId || (rows.current === undefined && parentId === null)) {
                                        hasFoundParent = true;
                                        oldQueryData.push([queryKey, rows]);
                                        newQueryData.push([queryKey, getUpdatedParent(rows)]);
                                        continue;
                                    }
                                    pathSegments = rows.path.split('_');
                                    sheetRowIdSegments = pathSegments.map(function (s) { return s.split(':')[0]; });
                                    if (sheetRowIdSegments.includes("".concat(id))) {
                                        oldQueryData.push([queryKey, rows]);
                                        newQueryData.push([queryKey, undefined]);
                                        continue;
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (allSearchedRows_1_1 && !allSearchedRows_1_1.done && (_f = allSearchedRows_1.return)) _f.call(allSearchedRows_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                            try {
                                for (newQueryData_1 = __values(newQueryData), newQueryData_1_1 = newQueryData_1.next(); !newQueryData_1_1.done; newQueryData_1_1 = newQueryData_1.next()) {
                                    _d = __read(newQueryData_1_1.value, 2), key = _d[0], data = _d[1];
                                    queryClient.setQueryData(key, data);
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (newQueryData_1_1 && !newQueryData_1_1.done && (_g = newQueryData_1.return)) _g.call(newQueryData_1);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            // parent was not found, find it now and filter children
                            if (!hasFoundParent && parentId !== undefined) {
                                parentData = allSearchedRows.filter(function (s) { var _a, _b; return ((_b = (_a = s[1]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.id) === (parentId !== null && parentId !== void 0 ? parentId : undefined); });
                                try {
                                    for (parentData_1 = __values(parentData), parentData_1_1 = parentData_1.next(); !parentData_1_1.done; parentData_1_1 = parentData_1.next()) {
                                        _e = __read(parentData_1_1.value, 2), key = _e[0], data = _e[1];
                                        if (!key || !data) {
                                            continue;
                                        }
                                        oldQueryData.push([key, data]);
                                        newQueryData.push([key, getUpdatedParent(data)]);
                                    }
                                }
                                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                finally {
                                    try {
                                        if (parentData_1_1 && !parentData_1_1.done && (_h = parentData_1.return)) _h.call(parentData_1);
                                    }
                                    finally { if (e_3) throw e_3.error; }
                                }
                            }
                            return [2 /*return*/, { oldQueryData: oldQueryData, oldList: oldList }];
                    }
                });
            });
        },
        onError: function (error, variables, context) {
            var e_4, _a;
            if (!context) {
                return;
            }
            //@ts-ignore
            queryClient.setQueryData(listKey, context.oldList);
            try {
                //@ts-ignore
                for (var _b = __values(context.oldQueryData), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), key = _d[0], data = _d[1];
                    queryClient.setQueryData(key, data);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        },
        onSuccess: function (error, variables, context) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, _b, _c, key, e_5_1;
                var e_5, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!context) {
                                return [2 /*return*/];
                            }
                            //@ts-ignore
                            return [4 /*yield*/, queryClient.invalidateQueries(listKey)];
                        case 1:
                            //@ts-ignore
                            _e.sent();
                            _e.label = 2;
                        case 2:
                            _e.trys.push([2, 7, 8, 9]);
                            _a = __values(context.oldQueryData), _b = _a.next();
                            _e.label = 3;
                        case 3:
                            if (!!_b.done) return [3 /*break*/, 6];
                            _c = __read(_b.value, 1), key = _c[0];
                            return [4 /*yield*/, queryClient.invalidateQueries(key)];
                        case 4:
                            _e.sent();
                            _e.label = 5;
                        case 5:
                            _b = _a.next();
                            return [3 /*break*/, 3];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            e_5_1 = _e.sent();
                            e_5 = { error: e_5_1 };
                            return [3 /*break*/, 9];
                        case 8:
                            try {
                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                            }
                            finally { if (e_5) throw e_5.error; }
                            return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        },
    });
}
function update(sheetRow) {
    var id = sheetRow.id, update = __rest(sheetRow, ["id"]);
    return sheetRowsApi.update(id, update);
}
export function useUpdateSheetRow() {
    var queryClient = useQueryClient();
    var allSearchesKey = sheetRowKeys.searches();
    var listKey = sheetRowKeys.list();
    return useMutation(update, {
        onMutate: function (variables) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var oldList, allSearchedRows, staleQueryKeys, targetQueryKey, oldSearch, allSearchedRows_2, allSearchedRows_2_1, _c, key, data, childrenCopy, i, child, pathSegments, sheetRowIdSegments;
                var e_6, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0: return [4 /*yield*/, queryClient.cancelQueries(listKey)];
                        case 1:
                            _e.sent();
                            return [4 /*yield*/, queryClient.cancelQueries(allSearchesKey)];
                        case 2:
                            _e.sent();
                            oldList = queryClient.getQueryData(listKey);
                            queryClient.setQueryData(listKey, function (data) {
                                if (!data) {
                                    return;
                                }
                                var targetIdx = data.findIndex(function (r) { return r.id === variables.id; });
                                if (targetIdx === -1) {
                                    return data;
                                }
                                var copy = __spreadArray([], __read(data), false);
                                copy[targetIdx] = __assign({}, copy[targetIdx]);
                                return copy;
                            });
                            allSearchedRows = queryClient.getQueriesData(allSearchesKey);
                            staleQueryKeys = [];
                            try {
                                for (allSearchedRows_2 = __values(allSearchedRows), allSearchedRows_2_1 = allSearchedRows_2.next(); !allSearchedRows_2_1.done; allSearchedRows_2_1 = allSearchedRows_2.next()) {
                                    _c = __read(allSearchedRows_2_1.value, 2), key = _c[0], data = _c[1];
                                    if (!data) {
                                        continue;
                                    }
                                    // update the row itself
                                    if (((_a = data.current) === null || _a === void 0 ? void 0 : _a.id) === variables.id) {
                                        oldSearch = data;
                                        targetQueryKey = key;
                                        queryClient.setQueryData(key, __assign(__assign({}, data), { current: __assign(__assign({}, data.current), variables) }));
                                        staleQueryKeys.push(key);
                                        continue;
                                    }
                                    // update parent
                                    if (((_b = data.current) === null || _b === void 0 ? void 0 : _b.id) === variables.parentId ||
                                        (variables.parentId === null && data.current === undefined)) {
                                        childrenCopy = __spreadArray([], __read(data.children), false);
                                        for (i = 0; i < childrenCopy.length; i++) {
                                            child = childrenCopy[i];
                                            if (child.id === variables.id) {
                                                childrenCopy[i] = __assign(__assign({}, child), variables);
                                                break;
                                            }
                                        }
                                        queryClient.setQueryData(key, __assign(__assign({}, data), { children: childrenCopy }));
                                        staleQueryKeys.push(key);
                                        continue;
                                    }
                                    pathSegments = data.path.split('_');
                                    sheetRowIdSegments = pathSegments.map(function (s) { return s.split(':')[0]; });
                                    if (sheetRowIdSegments.includes("".concat(variables.id))) {
                                        staleQueryKeys.push(key);
                                    }
                                }
                            }
                            catch (e_6_1) { e_6 = { error: e_6_1 }; }
                            finally {
                                try {
                                    if (allSearchedRows_2_1 && !allSearchedRows_2_1.done && (_d = allSearchedRows_2.return)) _d.call(allSearchedRows_2);
                                }
                                finally { if (e_6) throw e_6.error; }
                            }
                            return [2 /*return*/, { oldList: oldList, oldSearch: oldSearch, staleQueryKeys: staleQueryKeys, targetQueryKey: targetQueryKey }];
                    }
                });
            });
        },
        onError: function (error, variables, context) {
            //@ts-ignore
            if ((context === null || context === void 0 ? void 0 : context.targetQueryKey) && context.targetQueryKey) {
                queryClient.setQueryData(
                //@ts-ignore
                context.targetQueryKey, 
                //@ts-ignore
                context.oldSearch);
            }
            //@ts-ignore
            queryClient.setQueryData(listKey, context === null || context === void 0 ? void 0 : context.oldList);
        },
        onSuccess: function (data, variables, context) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var _b, _c, key, e_7_1;
                var e_7, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(listKey)];
                        case 1:
                            _e.sent();
                            _e.label = 2;
                        case 2:
                            _e.trys.push([2, 7, 8, 9]);
                            _b = __values((_a = context === null || context === void 0 ? void 0 : context.staleQueryKeys) !== null && _a !== void 0 ? _a : []), _c = _b.next();
                            _e.label = 3;
                        case 3:
                            if (!!_c.done) return [3 /*break*/, 6];
                            key = _c.value;
                            return [4 /*yield*/, queryClient.invalidateQueries(key)];
                        case 4:
                            _e.sent();
                            _e.label = 5;
                        case 5:
                            _c = _b.next();
                            return [3 /*break*/, 3];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            e_7_1 = _e.sent();
                            e_7 = { error: e_7_1 };
                            return [3 /*break*/, 9];
                        case 8:
                            try {
                                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                            }
                            finally { if (e_7) throw e_7.error; }
                            return [7 /*endfinally*/];
                        case 9:
                            //@ts-ignore
                            if (context === null || context === void 0 ? void 0 : context.targetQueryKey) {
                                //@ts-ignore
                                return [2 /*return*/, queryClient.invalidateQueries(context === null || context === void 0 ? void 0 : context.targetQueryKey)];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
    });
}
function createSearchParitalDataFn(queryClient, path, expressions) {
    //find current from parent and return a partial representation if exists
    return function () {
        var e_8, _a, e_9, _b;
        var _c, _d;
        var sheetRowPath = new SheetRowPath(path);
        var parentSegment = sheetRowPath.segments[sheetRowPath.segments.length - 2];
        if (!parentSegment) {
            return;
        }
        //expressions is undefined when using root or selected sheet row hooks that's why we won't get a cache hit and need to use [...sheetRowKeys.searches(), parentSegment.fullPath]
        var key = expressions
            ? sheetRowKeys.search((_c = parentSegment.fullPath) !== null && _c !== void 0 ? _c : '', expressions)
            : __spreadArray(__spreadArray([], __read(sheetRowKeys.searches()), false), [parentSegment.fullPath], false);
        var parentData = (_d = queryClient.getQueriesData(key)) !== null && _d !== void 0 ? _d : [];
        var targetChild;
        try {
            outer: for (var parentData_2 = __values(parentData), parentData_2_1 = parentData_2.next(); !parentData_2_1.done; parentData_2_1 = parentData_2.next()) {
                var _e = __read(parentData_2_1.value, 2), data = _e[1];
                if (!data) {
                    continue;
                }
                try {
                    for (var _f = (e_9 = void 0, __values(data.children)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var child = _g.value;
                        if (child.id === sheetRowPath.sheetRowId) {
                            targetChild = child;
                            break outer;
                        }
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (parentData_2_1 && !parentData_2_1.done && (_a = parentData_2.return)) _a.call(parentData_2);
            }
            finally { if (e_8) throw e_8.error; }
        }
        if (!targetChild) {
            return;
        }
        return {
            path: sheetRowPath.toString(),
            current: targetChild,
            children: [],
        };
    };
}
function search(context) {
    var _a = __read(context.queryKey, 6), path = _a[2], expressions = _a[3], withDataChildren = _a[4], numberColumnsData = _a[5];
    return sheetRowsApi.search({
        path: path,
        withDataChildren: withDataChildren,
        numberColumnsData: numberColumnsData,
        withDataCompoundExpression: expressions === null || expressions === void 0 ? void 0 : expressions.withDataCompoundExpression,
        filterCompoundExpression: expressions === null || expressions === void 0 ? void 0 : expressions.filterCompoundExpression,
    });
}
export function useSheetRowSearch(path, options) {
    var queryClient = useQueryClient();
    var searchKey = sheetRowKeys.search(path);
    return useQuery(searchKey, search, __assign(__assign({}, options), { enabled: ((options === null || options === void 0 ? void 0 : options.enabled) === undefined || options.enabled) && !!path, 
        //using placeholder data so that the partial data does not get cached
        placeholderData: createSearchParitalDataFn(queryClient, path) }));
}
export function useSheetRowsSearch(queries) {
    var queryClient = useQueryClient();
    var sheetRowQueries = queries.map(function (q) {
        var expressions = {
            withDataCompoundExpression: q.withDataCompoundExpression,
            filterCompoundExpression: q.filterCompoundExpression,
        };
        return {
            queryKey: sheetRowKeys.search(q.path, expressions, q.withDataChildren, q.numberColumnsData),
            queryFn: search,
            enabled: q.enabled === undefined ? true : q.enabled,
            //using placeholder data so that the partial row data does not get cached
            placeholderData: createSearchParitalDataFn(queryClient, q.path, expressions),
        };
    });
    return useQueries({ queries: sheetRowQueries });
}
function duplicate(command) {
    var id = command.id, targetId = command.targetId;
    return sheetRowsApi.duplicate(id, { targetId: targetId });
}
export function useDuplicateSheetRow() {
    var queryClient = useQueryClient();
    return useMutation(duplicate, {
        onMutate: function (variables) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: 
                        //get target subtree, insert into new parent
                        return [4 /*yield*/, queryClient.cancelQueries(sheetRowKeys.all)];
                        case 1:
                            //get target subtree, insert into new parent
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        onSuccess: function (data, variables, context) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(sheetRowKeys.all)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    });
}
function move(command) {
    var id = command.id, parentId = command.parentId, order = command.order;
    return sheetRowsApi.move(id, { parentId: parentId, order: order });
}
export function useMoveSheetRow() {
    var queryClient = useQueryClient();
    var allSearchesKey = sheetRowKeys.searches();
    var forceFinderColumnInvalidation = useLocalData().forceFinderColumnInvalidation;
    return useMutation(move, {
        onMutate: function (variables) {
            var _a, _b, _c, _d;
            return __awaiter(this, void 0, void 0, function () {
                var allSearchedRows, removedElements, toReorder, toRemove, allSearchedRows_3, allSearchedRows_3_1, _e, queryKey, rows, key, parentId, update_1, _f, _g, child, toReorder_1, toReorder_1_1, _h, data, key, expKey, target, childrenCopy, reorderedChildren, update_2;
                var e_10, _j, e_11, _k, e_12, _l;
                return __generator(this, function (_m) {
                    queryClient.cancelQueries(allSearchesKey);
                    allSearchedRows = queryClient.getQueriesData(allSearchesKey);
                    removedElements = new Map();
                    toReorder = [];
                    toRemove = [];
                    try {
                        for (allSearchedRows_3 = __values(allSearchedRows), allSearchedRows_3_1 = allSearchedRows_3.next(); !allSearchedRows_3_1.done; allSearchedRows_3_1 = allSearchedRows_3.next()) {
                            _e = __read(allSearchedRows_3_1.value, 2), queryKey = _e[0], rows = _e[1];
                            if (!rows) {
                                continue;
                            }
                            key = queryKey;
                            parentId = variables.parentId;
                            // current is undefined on root search path "0"
                            if (((_a = rows.current) === null || _a === void 0 ? void 0 : _a.id) === parentId || (rows.current === undefined && variables.parentId === null)) {
                                //Can be with or without compound expression key hence there can be multiple cached values in diferent keys for the same path;
                                toReorder.push({ key: key, data: rows });
                                if (rows.children.some(function (c) { return c.id === variables.id; })) {
                                    continue;
                                }
                            }
                            if (rows === null || rows === void 0 ? void 0 : rows.children.some(function (c) { return c.id === variables.id; })) {
                                //Same thing here
                                toRemove.push({ key: key, data: rows });
                                update_1 = __assign(__assign({}, rows), { current: rows.current ? __assign({}, rows.current) : undefined, children: [] });
                                try {
                                    for (_f = (e_11 = void 0, __values(rows.children)), _g = _f.next(); !_g.done; _g = _f.next()) {
                                        child = _g.value;
                                        if (child.id === variables.id) {
                                            removedElements.set((_b = JSON.stringify(key[3])) !== null && _b !== void 0 ? _b : '', child);
                                            continue;
                                        }
                                        update_1.children.push(__assign({}, child));
                                    }
                                }
                                catch (e_11_1) { e_11 = { error: e_11_1 }; }
                                finally {
                                    try {
                                        if (_g && !_g.done && (_k = _f.return)) _k.call(_f);
                                    }
                                    finally { if (e_11) throw e_11.error; }
                                }
                                // update chevron indicator
                                if (update_1.children.length === 0 && update_1.current) {
                                    update_1.current.hasChildren = false;
                                }
                                queryClient.setQueryData(key, update_1);
                            }
                        }
                    }
                    catch (e_10_1) { e_10 = { error: e_10_1 }; }
                    finally {
                        try {
                            if (allSearchedRows_3_1 && !allSearchedRows_3_1.done && (_j = allSearchedRows_3.return)) _j.call(allSearchedRows_3);
                        }
                        finally { if (e_10) throw e_10.error; }
                    }
                    try {
                        for (toReorder_1 = __values(toReorder), toReorder_1_1 = toReorder_1.next(); !toReorder_1_1.done; toReorder_1_1 = toReorder_1.next()) {
                            _h = toReorder_1_1.value, data = _h.data, key = _h.key;
                            expKey = (_c = JSON.stringify(key[3])) !== null && _c !== void 0 ? _c : '';
                            target = (_d = removedElements.get(expKey)) !== null && _d !== void 0 ? _d : data.children.find(function (c) { return c.id === variables.id; });
                            if (!target) {
                                continue;
                            }
                            childrenCopy = removedElements.has(expKey) ? __spreadArray(__spreadArray([], __read(data.children), false), [target], false) : __spreadArray([], __read(data.children), false);
                            reorderedChildren = reorder(childrenCopy, target, variables.order);
                            update_2 = {
                                path: data.path,
                                current: data.current ? __assign(__assign({}, data.current), { hasChildren: reorderedChildren.length > 0 }) : undefined,
                                children: reorderedChildren,
                            };
                            queryClient.setQueryData(key, update_2);
                        }
                    }
                    catch (e_12_1) { e_12 = { error: e_12_1 }; }
                    finally {
                        try {
                            if (toReorder_1_1 && !toReorder_1_1.done && (_l = toReorder_1.return)) _l.call(toReorder_1);
                        }
                        finally { if (e_12) throw e_12.error; }
                    }
                    forceFinderColumnInvalidation();
                    return [2 /*return*/, { parentRowQueryData: toRemove, newParentRowQueryData: toReorder }];
                });
            });
        },
        onError: function (error, variables, context) {
            var e_13, _a, e_14, _b;
            if (!context) {
                return;
            }
            //@ts-ignore
            var parentData = context.parentRowQueryData;
            //@ts-ignore
            var newParentKey = context.newParentRowQueryData;
            try {
                for (var parentData_3 = __values(parentData), parentData_3_1 = parentData_3.next(); !parentData_3_1.done; parentData_3_1 = parentData_3.next()) {
                    var _c = parentData_3_1.value, key = _c.key, data = _c.data;
                    queryClient.setQueryData(key, data);
                }
            }
            catch (e_13_1) { e_13 = { error: e_13_1 }; }
            finally {
                try {
                    if (parentData_3_1 && !parentData_3_1.done && (_a = parentData_3.return)) _a.call(parentData_3);
                }
                finally { if (e_13) throw e_13.error; }
            }
            try {
                for (var newParentKey_1 = __values(newParentKey), newParentKey_1_1 = newParentKey_1.next(); !newParentKey_1_1.done; newParentKey_1_1 = newParentKey_1.next()) {
                    var _d = newParentKey_1_1.value, key = _d.key, data = _d.data;
                    queryClient.setQueryData(key, data);
                }
            }
            catch (e_14_1) { e_14 = { error: e_14_1 }; }
            finally {
                try {
                    if (newParentKey_1_1 && !newParentKey_1_1.done && (_b = newParentKey_1.return)) _b.call(newParentKey_1);
                }
                finally { if (e_14) throw e_14.error; }
            }
        },
        onSuccess: function (data, variables, context) {
            var e_15, _a, e_16, _b;
            //Get parent path and invalidate it
            if (!context) {
                return;
            }
            //@ts-ignore
            var parentData = context.parentRowQueryData;
            //@ts-ignore
            var newParentKey = context.newParentRowQueryData;
            try {
                for (var parentData_4 = __values(parentData), parentData_4_1 = parentData_4.next(); !parentData_4_1.done; parentData_4_1 = parentData_4.next()) {
                    var key = parentData_4_1.value.key;
                    queryClient.invalidateQueries(key);
                }
            }
            catch (e_15_1) { e_15 = { error: e_15_1 }; }
            finally {
                try {
                    if (parentData_4_1 && !parentData_4_1.done && (_a = parentData_4.return)) _a.call(parentData_4);
                }
                finally { if (e_15) throw e_15.error; }
            }
            try {
                for (var newParentKey_2 = __values(newParentKey), newParentKey_2_1 = newParentKey_2.next(); !newParentKey_2_1.done; newParentKey_2_1 = newParentKey_2.next()) {
                    var key = newParentKey_2_1.value.key;
                    queryClient.invalidateQueries(key);
                }
            }
            catch (e_16_1) { e_16 = { error: e_16_1 }; }
            finally {
                try {
                    if (newParentKey_2_1 && !newParentKey_2_1.done && (_b = newParentKey_2.return)) _b.call(newParentKey_2);
                }
                finally { if (e_16) throw e_16.error; }
            }
        },
    });
}
function materializeSheetRowBranch(path) {
    return sheetRowsApi.materialize({ path: path });
}
export function useMaterializeSheetRowBranch() {
    var queryClient = useQueryClient();
    return useMutation(materializeSheetRowBranch, {
        onMutate: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.cancelQueries(sheetRowKeys.all)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        onSuccess: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, queryClient.invalidateQueries(sheetRowKeys.all)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
    });
}
function getSheetRowActions() {
    return sheetRowsApi.actions();
}
export function useActionsBySheetRowId(options) {
    return usePermittedActionsList(sheetRowKeys.actions(), getSheetRowActions, __assign(__assign({}, options), { select: selectActionsBySheetRowId }));
}
